"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/*
 * @Author: your name
 * @Date: 2021-05-17 13:22:03
 * @LastEditTime: 2021-07-02 17:56:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \emwappopads\src\index.ts
 */
/**
 * 东财Wap站弹窗广告
 */
require('./modules/polyfill/promise.js');
require('./modules/polyfill/array_find.js');
require("./style/index.less");
var ad_data_1 = __importDefault(require("./modules/ad_data"));
var cookie_1 = __importDefault(require("./modules/cookie"));
var ADSystem = /** @class */ (function () {
    function ADSystem(pageid) {
        this.tc = null;
        this.fb = null;
        this.pageid = pageid;
    }
    /**
     * 初始化广告
     */
    ADSystem.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self, _data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self = this;
                        return [4 /*yield*/, self.loadData()];
                    case 1:
                        _data = _a.sent();
                        if (_data) {
                            self.initAd();
                            self.bindFun();
                        }
                        else {
                            console.log('该页面未读取到弹窗浮标广告数据');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 加载广告数据
     */
    ADSystem.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self, vx, search, pageid, phoneType, ref, url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self = this;
                        vx = this.isWechat() ? 'yes' : 'no';
                        search = this.isSearch() ? 'yes' : 'no';
                        pageid = (window.emtj_pageId == undefined) ? '' : window.emtj_pageId;
                        console.log(pageid);
                        phoneType = this.isIOS() ? 'ios' : 'android';
                        ref = '';
                        try {
                            if (document.referrer && document.referrer.length > 0) {
                                url = new URL(document.referrer);
                                ref = url.host;
                            }
                        }
                        catch (error) {
                            console.log('获取refffer 错误');
                        }
                        return [4 /*yield*/, ad_data_1["default"].getData(this.pageid, pageid, phoneType, search, vx, ref)];
                    case 1:
                        data = _a.sent();
                        if (data && data.length > 0) {
                            data.forEach(function (item) {
                                if (item.adpositioncode == 'qjyy_fb') {
                                    self.fb = item;
                                }
                                else if (item.adpositioncode == 'qjyy_tc') {
                                    self.tc = item;
                                }
                            });
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    /**
     * 广告
     */
    ADSystem.prototype.initAd = function () {
        var self = this;
        var isTc = self.tc != null ? true : false;
        var isFb = self.fb != null ? true : false;
        var html = "<div class='dc-layer-tc'></div><div class='dc-fb' style='font-size:12px !important' data-expose-adveid=" + (isFb ? self.fb.adlist[0].InfoEID : '') + "><img class='dc-fb-img' src=" + (isFb ? self.fb.adlist[0].IMAGEURL : '') + "><div class='dc-fb-cancel'></div></div><div class='dc-result-tc' id='dc-result-tc'  style='font-size:12px !important'><img data-expose-adveid=" + (isTc ? self.tc.adlist[0].InfoEID : '') + " class='dc-img' src=" + (isTc ? self.tc.adlist[0].IMAGEURL : '') + "><div class='dc-cancel'></div></div>";
        var ad = document.createElement('div');
        ad.innerHTML = html;
        document.body.appendChild(ad);
        self.showAd();
    };
    ADSystem.prototype.changeTcStyle = function () {
        try {
            var img = document.getElementById('dc-result-tc').querySelector('img');
            var tc = document.getElementById('dc-result-tc');
            if (img.clientHeight && img.clientHeight != 0) {
                tc.style.top = '35%';
                tc.style.marginTop = "-" + img.clientHeight * 3 / 8 + "px";
            }
        }
        catch (error) {
        }
    };
    ADSystem.prototype.showAd = function () {
        var self = this;
        var tc = document.getElementById('dc-result-tc');
        var layer = document.getElementsByClassName('dc-layer-tc')[0];
        var fb = document.getElementsByClassName('dc-fb')[0];
        var isTc = self.tc != null ? true : false;
        var isFb = self.fb != null ? true : false;
        if (isTc == true && isFb == true) {
            // 首先判断是否为当天是否曝光过弹窗广告
            if (cookie_1["default"].getCookie("ad_tc_load_date")) {
                // 曝光过弹窗广告,则当天不再弹窗
                // 然后浮标是否显示
                if (cookie_1["default"].getCookie("ad_fb_load")) {
                    //当日用户已经关闭，则浮标不再显示
                }
                else {
                    fb.style.display = 'block';
                }
                try {
                    if (window.sendExposeTrackLog) {
                        window.sendExposeTrackLog();
                    }
                }
                catch (error) {
                }
            }
            else {
                // 没有曝光过弹窗广告
                // 其次判断这个弹窗广告之前是否弹过
                if (cookie_1["default"].getCookie("ad_tc_" + self.tc.adlist[0].InfoEID)) {
                    // 已经埋过cookie 不予展示弹窗 展示小图标
                    if (cookie_1["default"].getCookie("ad_fb_load")) {
                        //当日用户已经关闭，则浮标不再显示
                    }
                    else {
                        fb.style.display = 'block';
                    }
                    try {
                        if (window.sendExposeTrackLog) {
                            window.sendExposeTrackLog();
                        }
                    }
                    catch (error) {
                    }
                }
                else {
                    //当天没谈过弹窗广告，切历史埋点未发现该广告埋点，则显示弹窗广告
                    setTimeout(function () {
                        //3s后弹出弹窗
                        tc.style.display = 'block';
                        layer.style.display = 'block';
                        cookie_1["default"].setCookie("ad_tc_" + self.tc.adlist[0].InfoEID, true, 14);
                        self.setCookieToday("ad_tc_load_date", true);
                        self.changeTcStyle();
                        try {
                            if (window.sendExposeTrackLog) {
                                window.sendExposeTrackLog();
                            }
                        }
                        catch (error) {
                        }
                    }, 3000);
                }
            }
        }
        if (isTc == true && isFb == false) {
            // 首先判断是否为当天是否曝光过弹窗广告
            if (cookie_1["default"].getCookie("ad_tc_load_date")) {
                // 曝光过弹窗广告,则当天不再弹窗
            }
            else {
                // 没有曝光过弹窗广告
                // 其次判断这个弹窗广告之前是否弹过
                if (cookie_1["default"].getCookie("ad_tc_" + self.tc.adlist[0].InfoEID)) {
                    // 已经埋过cookie 不予展示弹窗
                }
                else {
                    //当天没谈过弹窗广告，切历史埋点未发现该广告埋点，则显示弹窗广告
                    setTimeout(function () {
                        //3s后弹出弹窗
                        tc.style.display = 'block';
                        layer.style.display = 'block';
                        cookie_1["default"].setCookie("ad_tc_" + self.tc.adlist[0].InfoEID, true, 14);
                        self.setCookieToday("ad_tc_load_date", true);
                        self.changeTcStyle();
                        try {
                            if (window.sendExposeTrackLog) {
                                window.sendExposeTrackLog();
                            }
                        }
                        catch (error) {
                        }
                    }, 3000);
                }
            }
        }
        if (isTc == false && isFb == true) {
            // 首先判断是否为当天是否曝光过弹窗广告
            if (cookie_1["default"].getCookie("ad_fb_load")) {
                //当日用户已经关闭，则浮标不再显示
            }
            else {
                fb.style.display = 'block';
            }
            try {
                if (window.sendExposeTrackLog) {
                    window.sendExposeTrackLog();
                }
            }
            catch (error) {
            }
        }
    };
    ADSystem.prototype.isWechat = function () {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * 判断是否来源于搜索引擎
     * @returns
     */
    ADSystem.prototype.isSearch = function () {
        var ref = window.document.referrer == "" ? "no referrer" : window.document.referrer;
        var arr = ['bing.com', 'baidu.com', 'so.com', 'google.com', 'yahoo.com', 'sohu.com', 'sougou.com'];
        return (arr.some(function (v) {
            return ref.indexOf(v) >= 0;
        }));
    };
    /**
     * 判断当前设备是安卓还是IOS
     * @returns
     */
    ADSystem.prototype.isIOS = function () {
        var userAgentInfo = window.navigator.userAgent, Agents = ["iPhone", "iPad", "iPod"];
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                return true;
            }
        }
        return false;
    };
    /**
     * 绑定事件
     */
    ADSystem.prototype.bindFun = function () {
        var self = this;
        self.mousemove();
        self.clickFun();
    };
    ADSystem.prototype.mousemove = function () {
        var fb = document.getElementsByClassName('dc-fb')[0];
        var longClick = 0, timeOutEvent, fb_x, fb_y;
        var screenWidth = document.documentElement.clientWidth, screenHeight = document.documentElement.clientHeight;
        fb.addEventListener("touchstart", function (e) {
            //阻止页面的滑动默认事件
            //e.preventDefault();
            timeOutEvent = setTimeout(function () {
                //此处为长按事件-----在此显示遮罩层及删除按钮
                longClick = 1; //假如长按，则设置为1,当为1的时候，才可以继续触发后续操作
            }, 0);
        }, false);
        fb.addEventListener("touchmove", function (e) {
            if (longClick == 0) {
                clearTimeout(timeOutEvent);
                timeOutEvent = 0;
            }
            else {
                e.preventDefault();
                fb.style.bottom = 0;
                fb.style.right = 0;
                fb_x = (e.changedTouches[0].clientX - fb.offsetWidth / 2);
                fb_y = (e.changedTouches[0].clientY - fb.offsetHeight / 2);
                if (fb_x < 0) {
                    fb_x = 0;
                }
                else if (fb_x > (screenWidth - fb.offsetWidth)) {
                    fb_x = screenWidth - fb.offsetWidth;
                }
                else {
                }
                if (fb_y < 0) {
                    fb_y = 0;
                }
                else if (fb_y > (screenHeight - fb.offsetHeight)) {
                    fb_y = screenHeight - fb.offsetHeight;
                }
                else {
                }
                fb.style.left = fb_x + 'px';
                fb.style.top = fb_y + 'px';
            }
        }, false);
        fb.addEventListener("touchend", function (e) {
            if (longClick == 0) {
                clearTimeout(timeOutEvent);
                timeOutEvent = 0;
            }
            else {
                setTimeout(function () {
                    longClick = 0;
                }, 1000);
            }
            return false;
        }, false);
    };
    ADSystem.prototype.clickFun = function () {
        var self = this;
        var layer = document.getElementsByClassName('dc-layer-tc')[0];
        var tc = document.getElementById('dc-result-tc');
        var tc_img = document.getElementsByClassName('dc-img')[0];
        var tc_cancel = document.getElementsByClassName('dc-cancel')[0];
        var fb = document.getElementsByClassName('dc-fb')[0];
        var fb_img = document.getElementsByClassName('dc-fb-img')[0];
        var fb_cancel = document.getElementsByClassName('dc-fb-cancel')[0];
        var isTc = self.tc != null ? true : false;
        var isFb = self.fb != null ? true : false;
        if (isTc) {
            tc_cancel.onclick = function () {
                //点去X号 埋点暂无
                tc.style.display = 'none';
                layer.style.display = 'none';
                if (isFb) {
                    if (cookie_1["default"].getCookie("ad_fb_load")) {
                        //当日用户已经关闭，则浮标不再显示
                    }
                    else {
                        fb.style.display = 'block';
                    }
                }
                try {
                    if (window.sendExposeTrackLog) {
                        window.sendExposeTrackLog();
                        window.sendTrackLog('div', 'click', 'ad.djxd', "{\"adID\":\"" + self.tc.adlist[0].InfoEID + "\"}");
                    }
                }
                catch (error) {
                }
            };
            tc_img.onclick = function () {
                // 点击中心图片跳转 埋点暂无
                try {
                    window.sendTrackLog('div', 'click', 'ad.click', "{\"adID\":\"" + self.tc.adlist[0].InfoEID + "\"}");
                    window.location.href = self.tc.adlist[0].JumpUrl;
                }
                catch (error) {
                }
            };
        }
        if (isFb) {
            fb_img.onclick = function () {
                //点击右下角图标跳转 埋点暂无
                try {
                    window.sendTrackLog('div', 'click', 'ad.click', "{\"adID\":\"" + self.fb.adlist[0].InfoEID + "\"}");
                    window.location.href = self.fb.adlist[0].JumpUrl;
                }
                catch (error) {
                }
            };
            fb_cancel.onclick = function () {
                //点击右下角图标跳转 埋点暂无
                fb.style.display = 'none';
                self.setCookieToday("ad_fb_load", true);
                try {
                    window.sendTrackLog('div', 'click', 'ad.djxd', "{\"adID\":\"" + self.fb.adlist[0].InfoEID + "\"}");
                }
                catch (error) {
                }
            };
        }
    };
    ADSystem.prototype.setCookieToday = function (name, value) {
        //当前日期
        var curDate = new Date();
        //当前时间戳
        var curTime = curDate.getTime();
        //当日凌晨的时间戳, 减去一毫秒是为了防止后续得到的时间不会达到00:00:00的状态
        var curStartHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
        //当日已经过去的时间（毫秒）
        var passedTime = curTime - curStartHours;
        //当日剩余时间
        var leftTamp = 24 * 60 * 60 * 1000 - passedTime;
        var leftTime = new Date();
        leftTime.setTime(leftTamp + curTime);
        //创建cookie
        document.cookie = name + "=" + escape(value) + ";expires=" + leftTime.toGMTString() + ";domain=eastmoney.com;path=/";
    };
    return ADSystem;
}());
var demo = new ADSystem('appwap_qjyy');
setTimeout(function () {
    demo.init();
}, 50);
